import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '../../../../utils/@reduxjs/toolkit';
import { ContainerState } from './types';

export const initialState: ContainerState = {
    data: {
        selectedYear: '',
        years: [],
        weeklyFiles: [],
        lastWeeklyDate: '',
    },
    isLoading: false,
    hasError: false,
    errorMessage: null,
};

const dataCoverage = createSlice({
    name: 'dataCoverage',
    initialState,
    reducers: {
        getSelectedYear(state: any, { payload }: PayloadAction<object | undefined>) {
            return {
                ...state,
                data: {
                    ...state.data,
                    selectedYear: payload,
                },
            };
        },
        getYears(state: any, { payload }: PayloadAction<object | undefined>) {
            return {
                ...state,
                isLoading: true,
                hasError: false,
            };
        },
        getWeeklyFiles(state: any, { payload }: PayloadAction<object | undefined>) {
            return {
                ...state,
                isLoading: true,
                hasError: false,
            };
        },
        getLastWeeklyDate(state: any, { payload }: PayloadAction<object | undefined>) {
            return {
                ...state,
                isLoading: true,
                hasError: false,
            };
        },
        getYearsSuccess(state: any, { payload }: PayloadAction<object | null>) {
            return {
                ...state,
                data: {
                    ...state.data,
                    years: payload,
                },
                isLoading: false,
                hasError: false,
            };
        },
        getYearsError(state: any, { payload }: PayloadAction<Error>) {
            return {
                ...state,
                isLoading: false,
                hasError: true,
                errorMessage: payload,
            };
        },
        getWeeklyFilesSuccess(state: any, { payload }: PayloadAction<object | null>) {
            return {
                ...state,
                data: {
                    ...state.data,
                    weeklyFiles: payload,
                },
                isLoading: false,
                hasError: false,
            };
        },
        getWeeklyFilesError(state: any, { payload }: PayloadAction<Error>) {
            return {
                ...state,
                isLoading: false,
                hasError: true,
                errorMessage: payload,
            };
        },
        getLastWeeklyDateSuccess(state: any, { payload }: PayloadAction<object | null>) {
            return {
                ...state,
                data: {
                    ...state.data,
                    lastWeeklyDate: payload,
                },
                isLoading: false,
                hasError: false,
            };
        },
        getLastWeeklyDateError(state: any, { payload }: PayloadAction<Error>) {
            return {
                ...state,
                isLoading: false,
                hasError: true,
                errorMessage: payload,
            };
        },
        resetState() {
            return initialState;
        },
    },
});

export const { actions, reducer, name: sliceKey } = dataCoverage;
